import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RichEditorService {
  constructor() { }

  fixTextEditorInput(payload: any) {
    for(const key in payload){
      if(payload[key]?.data !== undefined){
        payload[key] = payload[key]?.data;
        console.log(payload[key]);
      }
    }
    return payload;
  }
}
